import { Component,Input,OnInit,EventEmitter,Output,OnChanges } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Event } from '@angular/router';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ProjConstants } from 'src/app/utils/proj.constant';;
import { HttpClient } from '@angular/common/http';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-mapsearch',
  templateUrl: './mapsearch.component.html',
  styleUrls: ['./mapsearch.component.scss']
})
export class MapsearchComponent implements OnInit {
  @Input() selectedLocation: string;
  @Input() collapseEvent: boolean;
  @Input() activeSideMenu: any;
  @Output() eventEmitter = new EventEmitter<Object>();
  displayLayerPanel: Boolean = false;
  displayLayerPanelList: string[] = [];
  searchTypePanel = "ALL";
  searchvalue : string;
  formatedData: object[] = [];
  searchactive: boolean = false;
  myControl = new FormControl();
  inDrinkingWaterStress:Boolean
  hideDist = false;
  hideMand = false;
  hideCity = false;
  hideRes = false;
  hideUlbs = false;

  constructor(private router: Router, private route: ActivatedRoute, private _formBuilder: FormBuilder,private http : HttpClient) {}

  ngOnInit() {

    if(this.router.url.split('/')[1] == 'drinkingwaterstress')
      this.inDrinkingWaterStress = true
    else
      this.inDrinkingWaterStress = false

    this.initializeOnStateLoad();
  }
  ngOnChanges(){
    if(!isNullOrUndefined(this.selectedLocation)) {
      this.searchvalue = this.selectedLocation.charAt(0).toUpperCase() + this.selectedLocation.slice(1).toLowerCase()
      this.formatedData = []
    }
  }
  initializeOnStateLoad(): void {
    this.displayLayerPanelList = ProjConstants.SEARCH_LEVELS;
    this.formatedData = [];
    this.displayLayerPanel = false;
    this.myControl.setValue(null);
  }
  selectedItem(data) {
    this.eventEmitter.emit(data);
    this.searchvalue = data.en.charAt(0).toUpperCase()+ data.en.slice(1).toLowerCase()
    this.formatedData = []
  }

  formatsearchdata(listdata) {
    this.formatedData = [];
    listdata.forEach((value, key) => {
      if (this.formatedData.length == 0) {
          this.formatedData.push({
            'group': value['et'],
            'list': [value]
          })
      } else {
        let index = this.formatedData.findIndex(x => x['group'] === value['et']);
        if(index > -1 && this.displayLayerPanelList.includes(value['et'].toUpperCase())){
          this.formatedData[index]['list'].push(value)
        } else {
            this.formatedData.push({
              'group': value['et'],
              'list': [value]
            })
        }
      }
    })
    if(this.router.url.split('/')[1]!='drinkingwaterstress'){
      let tempData = []
      this.formatedData.forEach(e=>{
        if(e['group'] != 'ulb'){
          tempData.push(e)
        }
      })
      this.formatedData=tempData
    }
    this.getCatagories()
  }

  async applyFilter(name) {
    this.hideDist = false;
    this.hideMand = false;
    this.hideUlbs = false;
    this.hideCity = false;
    this.hideRes = false
    let combineddata = [];
    this.formatedData = [];
    let postdata = {};
    postdata['phrase'] = name
    postdata['size'] = 100;
    postdata['ct'] = "GEODATA";
    let promises;
    if(this.searchTypePanel && this.searchTypePanel != 'ALL'){
      // if(this.searchTypePanel == 'ULB'){
        postdata["index"] = "dims_india"
      // }
      postdata['et'] = this.searchTypePanel.toLocaleLowerCase();
      promises = await this.getsearchData(postdata)
      this.formatsearchdata(promises)
    } else {
      this.displayLayerPanelList.forEach((key) =>{
        if(key != 'ALL'){
          if(key !='ULB'){
            postdata['et'] = key.toLocaleLowerCase();
            postdata["index"] = "dims_india"
          }else{
            postdata['et'] = key.toLocaleLowerCase();
            postdata["index"] = "dims_india"
          }
        this.getsearchData(postdata).then(data => {
          promises = data
          combineddata = combineddata.concat(promises)
          this.formatsearchdata(combineddata)
        });
        }
      })
    }
  }

  getCatagories(){
    let fDset = new Set();
    this.formatedData.forEach(e => {
      fDset.add(e['group'])
    })
    // console.log('formatedData',this.formatedData);

    // console.log('et set', fDset)
    return fDset
  }

  getsearchData(postdata) {
    let promise = new Promise((resolve, reject) => {
      this.searchactive = true;
      this.http.post(ProjConstants.API_URL_SEARCH + "search",postdata).subscribe(data => {
        this.searchactive = false;
        if (data && data['result'] && data['result']['content']) {
          return resolve(data['result']['content']);
        }
        else
          return reject([]);
      })

    })
    return promise;
  }

  displaypanelclick(item) {
    this.formatedData = [];
    this.searchvalue = '';
    this.searchTypePanel = item;
    this.displayLayerPanel = false;
    this.myControl.setValue(null);
    // console.log('this.route.url',this.router.url.split('/'))
  }

  togHidecategory(grp){
    // console.log('grp',grp)
    if(grp == 'ulb')
      this.hideUlbs = !this.hideUlbs
    else if (grp == 'DISTRICT')
      this.hideDist = !this.hideDist
    else if(grp == 'BLOCK')
      this.hideMand = !this.hideMand
    else if(grp == 'CITY')
      this.hideCity = !this.hideCity
    else if(grp == 'RESERVOIR')
      this.hideRes = !this.hideRes
  }

  getHidStatus(grp){
    if(grp == 'ulb')
      return this.hideUlbs;
    else if (grp == 'DISTRICT')
      return this.hideDist;
    else if (grp == 'BLOCK')
      return this.hideMand
    else if (grp == 'CITY')
      return this.hideCity
    else if (grp == 'RESERVOIR')
      return this.hideRes
  }
}
